import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface InventoryItem {
  id: string;
  name: string;
  systemQuantity: number;
  countedQuantity: number;
  difference: number;
  notes?: string;
}

interface InventoryTableProps {
  items: InventoryItem[];
}

export const InventoryTable = ({ items }: InventoryTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Produit</TableHead>
          <TableHead>Quantité système</TableHead>
          <TableHead>Quantité comptée</TableHead>
          <TableHead>Différence</TableHead>
          <TableHead>Notes</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item: InventoryItem, index: number) => (
          <TableRow key={`${item.id}-${index}`}>
            <TableCell>{item.name}</TableCell>
            <TableCell>{item.systemQuantity}</TableCell>
            <TableCell>{item.countedQuantity}</TableCell>
            <TableCell className={item.difference !== 0 ? "text-red-600" : "text-green-600"}>
              {item.difference}
            </TableCell>
            <TableCell>{item.notes || "-"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};